import {serializeFilters} from 'nutshell-core';

import type {ReportGap, FilterObject} from 'nutshell-core/types';

const CONNECTED_FORM_TYPE = 1;

export type ConnectedFormChartParams = {
    gap: ReportGap;
};

export type ConnectedFormReportPostParams = {
    filter: any;
    gap: ReportGap;
};

export function getReportPostParams(
    reportParams: ConnectedFormChartParams,
    filters: FilterObject[]
): ConnectedFormReportPostParams {
    const {gap} = reportParams;

    return {
        filter: serializeFilters(filters),
        gap,
        // @ts-expect-error
        formType: CONNECTED_FORM_TYPE,
    };
}
